module.exports = __webpack_public_path__ + "static/media/hi-from-commish.1dd020d9.mp3";